export const currencies = [
    { code: 'USD', name: 'DOLAR USA' },
    { code: 'CLP', name: 'PESO CL' },
    { code: 'EUR', name: 'EURO' },
    { code: 'GBP', name: 'LIBRA EST' },
    { code: 'JPY', name: 'YEN' },
    { code: 'PEN', name: 'NUEVO SOL' },
    { code: 'ARS', name: 'PESO' },
    { code: 'MXN', name: 'PESO MEX' },
    { code: 'COP', name: 'PESO COL' },
    { code: 'UYU', name: 'PESO URUG' },
    { code: 'BOB', name: 'BOLIVIANO' },
    { code: 'VES', name: 'BOLIVAR' },
    { code: 'BRL', name: 'CRUZEIRO REAL' },
    { code: 'CHF', name: 'FRANCO SZ' },
    { code: 'CNY', name: 'RENMINBI' },
    { code: 'INR', name: 'RUPIA' },
    { code: 'HKD', name: 'DOLAR HK' },
    { code: 'AUD', name: 'DOLAR AUST' },
    { code: 'CAD', name: 'DOLAR CAN' },
    { code: 'NZD', name: 'DOLAR NZ' },
    { code: 'SGD', name: 'DOLAR SIN' },
    { code: 'TWD', name: 'DOLAR TAI' },
    { code: 'ZAR', name: 'RAND' },
    { code: 'PYG', name: 'GUARANI' },
    { code: 'AED', name: 'DIRHAM' },
    { code: 'SEK', name: 'CORONA SC' },
    { code: 'NOK', name: 'CORONA NOR' },
    { code: 'DKK', name: 'CORONA DIN' },
    { code: 'DEM', name: 'MARCO AL' },
    { code: 'FIM', name: 'MARCO FIN' },
    { code: 'GRD', name: 'DRACMA' },
    { code: 'ESP', name: 'PESETA' },
    { code: 'PTE', name: 'ESCUDO' },
    { code: 'ANG', name: 'FLORIN' }
]